import React from "react";
import Banner from "../components/allbanner";
import orgChart from "../images/chart.png";
import s1 from "../images/service1.jpeg";
import s2 from "../images/service2.jpg";
import s3 from "../images/service3.jpg";
import {
  MessageCircle
} from "lucide-react";

const ServicePage = () => {
  const serviceHighlights = [
    "Scheduled Maintenance Programs",
    "Emergency Repair Services",
    "Warranty & Genuine Parts Support",
    "Mobile Service Units for Fleet Customers",
  ];

  const serviceImages = [s1, s2, s3];

  return (
    <div className="pb-12 bg-white text-gray-800">
      {/* Banner */}
      <Banner
        title="Vehicle Service"
        description="Keep your Isuzu Gujranwala performing at its peak with expert maintenance, advanced diagnostics, and genuine care from our certified service team."
      />

      {/* Service Area Section */}
      <section className="container mx-auto px-6 py-20 text-center">
        <h2 className="text-4xl font-extrabold text-[#D71920] mb-6 animate-fadeInUp">
          Service Department Overview
        </h2>
        <p className="text-gray-700 max-w-3xl mx-auto mb-8 leading-relaxed animate-fadeInUp delay-100">
          The Service Department consists of 30 trained employees, equipped with
          specialized service tools. Our aim is to provide the best workshop
          experience, enhancing customer trust and loyalty.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {serviceImages.map((img, i) => (
            <div
              key={i}
              className="rounded-2xl shadow-lg bg-gray-200 w-full h-64 overflow-hidden hover:scale-105 transition-transform duration-300 animate-fadeInUp"
            >
              <img
                src={img}
                alt={`Service ${i + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-20 bg-[#FFF5F5]">
  <div className="container mx-auto px-6">
    
    {/* Responsive layout: stacked on mobile, side-by-side on desktop */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">

      {/* Our Mission */}
      <div>
        <h2 className="text-3xl font-extrabold text-gray-900 mb-4 border-l-4 border-[#D71920] pl-3 inline-block animate-fadeInUp">
          Our Mission
        </h2>
        <p className="text-gray-700 leading-relaxed animate-fadeInUp delay-100">
          Our mission is to deliver outstanding service and support to our customers by ensuring
          reliability, efficiency, and quality in every interaction. We are committed to providing
          timely solutions, minimizing downtime, and enhancing customer satisfaction through
          technical expertise, proactive problem-solving, and continuous improvement.
        </p>
      </div>

      {/* Our Vision */}
      <div>
        <h2 className="text-3xl font-extrabold text-gray-900 mb-4 border-l-4 border-[#D71920] pl-3 inline-block animate-fadeInUp">
          Our Vision
        </h2>
        <p className="text-gray-700 leading-relaxed animate-fadeInUp delay-100">
          By prioritizing excellence and teamwork, we strive to be a trusted partner in meeting and
          exceeding customer needs, ensuring every Isuzu Gujranwala remains reliable, efficient, and
          road-ready.
        </p>
      </div>

    </div>
  </div>
</section>



      {/* Service Team Structure */}
      <section className="container mx-auto px-6 py-20 text-center">
        <h2 className="text-4xl font-extrabold text-[#D71920] mb-6 animate-fadeInUp">
          Service Team Structure
        </h2>
        <img
          src={orgChart}
          alt="Service Department Organization Chart"
          className="mx-auto rounded-xl shadow-lg max-w-full h-auto animate-fadeInUp delay-100"
        />
      </section>

      {/* Highlights Section */}
      <section className="container mx-auto px-6 py-20 text-center">
        <h2 className="text-4xl font-extrabold text-[#D71920] mb-6 animate-fadeInUp">
          Comprehensive Service Solutions
        </h2>
        <p className="text-gray-700 max-w-3xl mx-auto mb-14 leading-relaxed animate-fadeInUp delay-100">
          From preventive maintenance to complete overhauls, our expert team
          ensures your Isuzu Gujranwala stays powerful, efficient, and road-ready. We
          combine precision engineering with genuine parts to deliver unmatched
          reliability.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {serviceHighlights.map((item, i) => (
            <div
              key={i}
              className="bg-white border border-[#D71920]/20 p-8 rounded-2xl shadow-md hover:shadow-lg hover:border-[#D71920] transition-all duration-300 animate-fadeInUp"
            >
              <div className="flex flex-col items-center text-center">
                <div className="bg-[#D71920] text-white rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold mb-4 shadow-md">
                  ✓
                </div>
                <h3 className="font-semibold text-lg text-gray-800">{item}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="w-full -mb-12 py-20 px-6 text-white bg-gradient-to-r from-[#D71920] to-[#A50E0E] text-center">
        <h2 className="text-4xl font-extrabold mb-4 animate-fadeInUp">
          Schedule Your Service Appointment
        </h2>
        <p className="max-w-2xl mx-auto mb-10 text-lg animate-fadeInUp delay-100 opacity-90">
          Book your appointment online and keep your Isuzu in top condition — strong, reliable, and ready for any road ahead.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 animate-fadeInUp delay-200">
          <a
            href="/contact"
            className="bg-white text-[#D71920] font-bold px-8 py-3 rounded-xl shadow-lg hover:bg-gray-100 transition-all inline-flex items-center gap-2"
          >
            Book Service Appointment
          </a>

          <a
            href={`https://wa.me/923129388531?text=${encodeURIComponent(
              "Hello! I’d like to schedule a service appointment for my Isuzu vehicle."
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white font-semibold px-8 py-3 rounded-xl shadow-lg transition-all inline-flex items-center gap-2"
          >
            <MessageCircle className="w-5 h-5" />
            WhatsApp Us
          </a>
        </div>
      </section>


      {/* Animations */}
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease forwards;
        }
        .delay-100 {
          animation-delay: 0.1s;
        }
        .delay-200 {
          animation-delay: 0.2s;
        }
      `}</style>
    </div>
  );
};

export default ServicePage;
